import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { FormControl, FormLabel, Checkbox } from '@chakra-ui/react';

import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';

type Props = {
  register: UseFormRegister<NotificationFormFields>;
};

/**
 * お知らせ種別のフォームです。
 * Chakra の Checkbox は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const LevelForm: FC<Props> = ({ register }) => (
  <FormControl>
    <FormLabel>お知らせ種別</FormLabel>
    <Checkbox id="isHigh" {...register('isHigh')}>
      重要なお知らせ
    </Checkbox>
  </FormControl>
);
